import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLogoSecondary from './svgs/LogoSecondary.js';
import SvgWordmarkPrimary from './svgs/WordmarkPrimary.js';
import { useIcon } from '../../shared-components/icon/index.js';

// Secondary Logo and Wordmark are identical
var wordmark = (props => useIcon(SvgWordmarkPrimary, SvgLogoSecondary, props));

export { wordmark as default };
